import { track } from './analytics';
import { SET_LESSON_STARTED } from '../store/meeting/actions/actionTypes';
import { OPEN_PLANS, SHOW_QUOTA_PAYWALL } from '../store/subscriptionUi/actionTypes';
import { SET_NEW_BADGES } from '../store/relicVault/actionTypes';

/**
 * Player events that the store already knows about (owner 2026-10-13: "mixpanel events all around the UX and user
 * journeys"; Sol mixpanel-coverage D1 A): a lesson starting and ending, the plans opening over the world, a used-up
 * minutes meter and newly earned badges. Watching the actions keeps the screens untouched. It only ever observes: an
 * error here is swallowed and never reaches the product.
 */
// The store's own action names (the badges one is RELIC_VAULT/SET_NEW_BADGES; a copied string missed it on 13 Oct).

const lessonOf = state => {
  const course = state?.course || {};
  return {
    course_id: course.courseData?.curriculumId || null,
    lesson_id: course.currentLessonProgress?.currentLessonId || course.courseData?.currentLessonId || null,
  };
};
const planOf = state => state?.subscriptionUi?.plan?.planKey || null;
export const meterName = meter => (['voice', 'text', 'course'].includes(meter) ? meter : meter ? 'other' : null);

export function createAnalyticsMiddleware(send = track, now = () => Date.now()) {
  let lesson = null; // { course_id, lesson_id, startedAt }
  const badgesSent = new Set();

  const observe = (action, before, after) => {
    switch (action?.type) {
      case SET_LESSON_STARTED: {
        const was = Boolean(before?.meeting?.meeting?.lessonStarted);
        const is = Boolean(after?.meeting?.meeting?.lessonStarted);
        if (!was && is) {
          lesson = { ...lessonOf(after), startedAt: now() };
          send('lesson_started', { course_id: lesson.course_id, lesson_id: lesson.lesson_id, entry_point: 'lesson_menu' });
        } else if (was && !is && lesson) {
          const progress = Number(after?.course?.currentLessonProgress?.currentLessonProgressPercentage) || 0;
          send('lesson_completed', {
            course_id: lesson.course_id,
            lesson_id: lesson.lesson_id,
            duration_seconds: Math.max(0, Math.round((now() - lesson.startedAt) / 1000)),
            completion_reason: progress >= 100 ? 'finished' : 'exited',
          });
          lesson = null;
        }
        break;
      }
      case SHOW_QUOTA_PAYWALL: {
        const kind = action.payload?.kind || 'quota';
        if (kind === 'ended') break; // a session that simply ended is not a limit and opens no plans
        const meter = meterName(action.payload?.meter);
        if (kind === 'quota') send('usage_meter_exhausted', { meter_type: meter, plan_tier: planOf(after) || action.payload?.planKey || null, trigger: meter === 'course' ? 'course_generation' : 'tutor_session' });
        send('player_paywall_viewed', { meter_type: meter, plan_tier: planOf(after), trigger: kind === 'quota' ? 'meter_exhausted' : 'locked_content' });
        break;
      }
      case OPEN_PLANS:
        send('player_paywall_viewed', { meter_type: null, plan_tier: planOf(after), trigger: 'upgrade' });
        break;
      case SET_NEW_BADGES:
        for (const id of Array.isArray(action.payload) ? action.payload : []) {
          if (id == null || badgesSent.has(String(id))) continue;
          badgesSent.add(String(id));
          send('badge_earned', { badge_id: String(id), trigger: 'play' });
        }
        break;
      default:
        break;
    }
  };

  return store => next => action => {
    let before;
    try {
      before = store.getState();
    } catch (_) {
      before = null;
    }
    const result = next(action);
    try {
      observe(action, before, store.getState());
    } catch (_) {
      // analytics never breaks the product
    }
    return result;
  };
}

export default createAnalyticsMiddleware();
